import http from '../API/httpServices'
import config from '../API/config.json'


export default function getMenu(menuId) {
  return http.get(`${config.apiEndpoint}menus/${menuId}`);
}


export function getDefaultForSlug(slug) {
  return http.get(`${config.apiEndpoint}restaurant/${slug}/defaultmenu`);
}
 

export function passLanguage(language) {
  return http.post(`${config.apiEndpoint}/${language}`)
}